import { ethers } from 'ethers';

// Format USDT (18 decimals on opBNB) to human-readable string
export const formatUsdt = (bnValue, decimals = 4) => {
  if (!bnValue) return '0';
  try {
    const s = ethers.utils.formatUnits(bnValue, 18);
    const num = parseFloat(s);
    if (num === 0) return '0';
    if (num < 0.0001) return '<0.0001';
    const fixed = num.toFixed(decimals);
    // Only strip trailing zeros AFTER a decimal point.
    // Bug fix: previously "50".replace(/\.?0+$/, '') stripped the trailing 0 → "5".
    // Now: only touch when a decimal point exists.
    if (fixed.includes('.')) {
      return fixed.replace(/\.?0+$/, '');
    }
    return fixed;
  } catch {
    return '0';
  }
};

// Parse human-readable USDT amount to BigNumber (18 decimals)
export const parseUsdt = (amount) => {
  try {
    return ethers.utils.parseUnits(String(amount), 18);
  } catch {
    return ethers.BigNumber.from(0);
  }
};

export const formatAddress = (addr, chars = 4) => {
  if (!addr) return '';
  return `${addr.slice(0, 2 + chars)}...${addr.slice(-chars)}`;
};

export const formatTimestamp = (ts) => {
  if (!ts) return '-';
  const timestamp = typeof ts === 'object' && ts.toNumber ? ts.toNumber() : Number(ts);
  if (timestamp === 0) return '-';
  const date = new Date(timestamp * 1000);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const timeAgo = (ts) => {
  if (!ts) return '-';
  const timestamp = typeof ts === 'object' && ts.toNumber ? ts.toNumber() : Number(ts);
  if (timestamp === 0) return '-';
  const seconds = Math.floor(Date.now() / 1000 - timestamp);
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
};

// bytes32 <-> string
export const stringToBytes32 = (str) => {
  const truncated = String(str).slice(0, 31);
  return ethers.utils.formatBytes32String(truncated);
};

export const bytes32ToString = (b32) => {
  if (!b32 || b32 === '0x0000000000000000000000000000000000000000000000000000000000000000') return '';
  try {
    return ethers.utils.parseBytes32String(b32);
  } catch {
    return '';
  }
};

// Activity type names (matches storage constants)
export const ACTIVITY_NAMES = {
  1: 'Registered',
  2: 'Package Activated',
  3: 'Direct Income',
  4: 'Level Income',
  5: 'Royalty Credited',
  6: 'Royalty Claimed',
  7: 'Held Income',
  8: 'Held Overflow',
  9: 'Auto Upgrade',
  10: 'Manual Upgrade',
  11: 'Held Released',
  12: 'Wallet Paid',
  13: 'Ceiling Hit',
  14: 'Missing Income',
  15: 'Blocked',
  16: 'Unblocked',
  18: 'Wallet Updated',
  19: 'Retopup'
};

export const getActivityName = (type) => ACTIVITY_NAMES[Number(type)] || `Type ${type}`;
